<div class="content bg-grey-hover-10">
    <ng-content></ng-content>
</div>